import angular from 'angular';
import uiRouter from 'angular-ui-router';
import pendingSpendingsComponent from './pendingspendings.component';
import dataTable from 'angular-material-data-table';

let pendingSpendingsModule = angular.module('pendingSpendings', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('pendingSpendings', {
        url: '/pending-spendings',
        component: 'pendingSpendings',
        parent: 'main',
        data: {
            permissions: {
                only: ['ADMIN', 'VOUCHERS'],
                redirectTo: 'home'
            }
        },
        resolve: {
            registries: (RegistriesService) => RegistriesService.find()
        }
    });
})
.component('pendingSpendings', pendingSpendingsComponent)
.name;

export default pendingSpendingsModule;
